import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import {
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { T4XMLListColumns } from "../../appconfig/DatatableSetting";
import { getAllDetails, postSingleData, postAllData } from "../../service/ProductService";
import { T4_XML_LIST, T4_XML } from "../../config/ApiConstant";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import moment from "moment";
import { useParams } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";

const EmployerT4XML = () => {
  document.title = "T4 XML | Nexawage Payroll";
  const toast = useRef<any>(null);
  const [pageLoad, setPageLoad] = useState<boolean>(false);
  const [employeeList, setEmployeeList] = useState<any>([]);

  const currentYear = moment().year();
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  const [addDeleteT4Dialog, setAddDeleteT4Dialog] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});
  const [summaryNumber, setSummaryNumber] = useState<any>({});

  // filters
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  const userRole = userData?.roles?.role_name || "";

  const { id }: any = useParams();
  const clientId = id ? atob(id) : null;

  // useefect for get user list
  useEffect(() => {
    getListEmployee();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [selectedYear]);

  // list-employee
  const getListEmployee = async () => {
    try {
      let idToSend = null;

      if (userRole === "Client") {
        idToSend = userData?.id;
      } else if (userRole === "Employee") {
        idToSend = userData?.id;
      } else {
        idToSend = clientId;
      }

      const response = await getAllDetails(`${T4_XML_LIST}/${idToSend}?year=${selectedYear}`);

      const data = response;

      if (data) {
        setEmployeeList(data || []);
        setPageLoad(true);
      } else {
        setEmployeeList([]);
        setPageLoad(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // add edit dialog
  const t4Dialog = async () => {
    setAddDeleteT4Dialog(true);
  };

  // hide add & edit t4 modal
  const hideAddEditT4Dialog = () => {
    setAddDeleteT4Dialog(false);
    setSubmitLoading(false);
    setSummaryNumber({});
    setErrors({});
  };

  const onInputChange = (e: any, name: string) => {
    let val = null;
    val = e?.target?.value ?? e?.value;

    setSummaryNumber({ ...summaryNumber, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };

  // submit T4 form directly
  const submitT4Form = async () => {
    if (!summaryNumber?.year) {
      setErrors({ year: "Year is required" });
      return;
    }
    if (summaryNumber?.year?.length !== 4) {
      setErrors({ year: "Year must be 4 digits" });
      return;
    }

    setSubmitLoading(true);

    try {
      const clientIdToUse = clientId || userData?.id;
      const year = summaryNumber?.year;

      const response = await postAllData(`${T4_XML}/${clientIdToUse}`, { year: Number(year) });

      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });

        const downloadUrl = response?.data?.t4_url || response?.data;

        if (downloadUrl) {
          try {
            const res = await fetch(downloadUrl);
            const blob = await res.blob();

            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = blobUrl;

            let filename = downloadUrl.split("/").pop() || `T4_Report_${year}.xml`;
            if (filename.includes("?")) filename = filename.split("?")[0];

            link.setAttribute("download", filename);

            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(blobUrl);
          } catch (error) {
            console.error("Download failed:", error);
          }
        }

        if (year) {
          setSelectedYear(Number(year));
        }

        hideAddEditT4Dialog();
        await getListEmployee();
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // clear all filter
  const clearAll = () => {
    setSelectedYear(currentYear);
    setGlobalFieldFilter(null);
    setGlobalFilter(null);
  };

  // left toolbar template
  const leftToolbarTemplate = () => <></>;

  // right toolbar template
  const rightToolbarTemplate = () => (
    <div className="payrollreport-template">
      {userRole !== "Employee" && (
        <>
          <Button className="ml-1 common-primary-button mr-3" icon="pi pi-plus" label="Generate T4 XML" onClick={() => t4Dialog()} />
        </>
      )}
    </div>
  );

  // view xml
  const viewXml = async (rowData: any,) => {
    const downloadUrl = rowData?.t4_url;

    if (downloadUrl) {
      try {
        const res = await fetch(downloadUrl);
        const blob = await res.blob();

        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;

        let filename = downloadUrl.split("/").pop() || `T4_Report_${rowData?.year}.xml`;
        if (filename.includes("?")) filename = filename.split("?")[0];

        link.setAttribute("download", filename);

        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error("Download failed:", error);
      }
    }
    else {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "XML NOT FOUND",
      });
    }
  };

  // payroll number template
  const payrollNumberTemplate = (rowData: any) => (
    <div>{rowData?.year}</div>
  );

  // action body template
  const actionBodyTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-file-excel"
        tooltip="View T4 XML"
        className="p-button-secondary common-view-pdf-btn"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => viewXml(rowData)}
      />
    </div>
  );

  return (
    <>
      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white lg:p-2 crud-demo">
            <Toast ref={toast} />
            <Toolbar className="gap-3" left={leftToolbarTemplate} right={rightToolbarTemplate} />
            {pageLoad ? (
              <DataTable
                value={employeeList}
                showGridlines
                responsiveLayout={"scroll"}
                dataKey="id"
                stripedRows
                rows={defaultRowOptions}
                paginator={employeeList?.length > 0}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatble-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries + " T4 XML Reports"}
                emptyMessage="No T4 XML Found"
                removableSort
              >
                {T4XMLListColumns.map((col, i) => {
                  if (col.field === "t4_url") {
                    return <Column key={col.field} field={col.field} header={col.header} body={actionBodyTemplate} />;
                  } else if (col.field === "year") {
                    return <Column key={col.field} field={col.field} header={col.header} body={payrollNumberTemplate} />;
                  } else {
                    return <Column key={col.field} field={col.field} header={col.header} />;
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {T4XMLListColumns.map((col) => (
                  <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                ))}
              </DataTable>
            )}
          </Card>
        </div>
      </div>

      {/* Generate t4 dialog */}
      <Dialog
        visible={addDeleteT4Dialog}
        style={{ width: "600px" }}
        draggable={false}
        className="mx-3 lg:mx-0"
        header={"Generate T4 XML"}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideAddEditT4Dialog} disabled={submitLoading} />
            <Button label="Submit" icon="pi pi-check" className="common-primary-button" onClick={submitT4Form} loading={submitLoading} />
          </div>
        }
        onHide={hideAddEditT4Dialog}
      >
        <h4 className="mb-4">Do you want to generate T4 XML ?</h4>
        <div className="grid p-fluid formgrid">
          <label htmlFor="year" className="flex align-items-center justify-content-center">
            Year *
          </label>
          <div className="field col-12 md:col-6 mb-0">
            <form autoComplete="off">
              <div className="flex-1 input-effect-div p-inputgroup">
                <Calendar
                  id="year"
                  value={summaryNumber.year ? moment(summaryNumber.year, "YYYY").toDate() : null}
                  onChange={(e) => {
                    const selectedDate = e.value;
                    if (selectedDate instanceof Date) {
                      const year = moment(selectedDate).year();
                      setSummaryNumber({ ...summaryNumber, year: String(year) });
                      setErrors({ ...errors, year: "" });
                    }
                  }}
                  view="year"
                  dateFormat="yy"
                  showIcon
                  placeholder="Select Year"
                  className={errors["year"] ? "p-invalid w-full" : "w-full"}
                />
              </div>
            </form>

            <small className="p-invalid-txt">{errors["year"]}</small>
          </div>
        </div>
      </Dialog>
    </>
  );
};
export default EmployerT4XML;
